import { useEffect, useState } from 'react';

/** The real OS-level `prefers-reduced-motion` preference — independent of
 * this app's own "Lite mode" toggle (App.js's MotionConfig ties framer-motion
 * globally to isLite, which is a data-saving preference, not an
 * accessibility one, so it doesn't actually respect this media feature).
 * Components that must honour prefers-reduced-motion regardless of Lite
 * mode (see HomeStats.js / HowItWorks.js) read this instead. */
export default function usePrefersReducedMotion() {
  const [reduced, setReduced] = useState(
    () => typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
  );

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const onChange = () => setReduced(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return reduced;
}
